import * as React from 'react';
import {
  CircularProgress,
  IconButton,
  IconButtonProps as ButtonProps,
  Tooltip
} from '@mui/material';

import { useMounted } from '../hooks';

export function SubmitIconButton({
  onClick,
  buttonProps,
  children,
  title
}: {
  onClick: () => Promise<void>;
  buttonProps?: ButtonProps;
  children: React.ReactNode;
  title: string;
}): JSX.Element {
  const [processing, setProcessing] = React.useState(false);

  const mounted = useMounted();
  const icon = processing ? <CircularProgress size={12} thickness={3} color='inherit' /> : children;

  if (processing || buttonProps?.disabled) {
    return (
      <IconButton title={title} {...buttonProps} disabled>
        {icon}
      </IconButton>
    );
  }

  return (
    <Tooltip title={title}>
      <IconButton
        onClick={(): void => {
          setProcessing(true);
          onClick().finally(() => {
            if (mounted.current) {
              setProcessing(false);
            }
          });
        }}
        aria-label={title}
        {...buttonProps}
        disabled={false}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
}
